export default __webpack_public_path__ + "static/mel-signup-asset-12f2485a19222a79069709d24f614aea.jpg";